import { useTranslation } from 'react-i18next';
import { useAuth } from '../../lib/auth';
import { api } from '../../lib/api';
import { useToast } from '../../lib/toast';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const { user } = useAuth();
  const toast = useToast();

  const handleLanguageChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLanguage = event.target.value;

    try {
      // Update language in backend if user is authenticated
      if (user) {
        await api.put('/api/settings/language', { language: newLanguage });
      }

      // Update i18n language
      await i18n.changeLanguage(newLanguage);

      // Store in localStorage
      localStorage.setItem('i18nextLng', newLanguage);

      toast.success('Language updated successfully');
    } catch (error) {
      toast.error('Failed to update language');
      console.error('Language update error:', error);
    }
  };

  return (
    <select
      value={i18n.language}
      onChange={handleLanguageChange}
      className="px-3 py-1.5 text-sm border border-gray-300 rounded-md bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      aria-label="Select language"
    >
      <option value="en">English</option>
      <option value="id">Bahasa Indonesia</option>
    </select>
  );
}
